import React, { useState } from "react";
import { useProfile } from "../../../features/auth/hooks/useProfile";
import useOrganization from "../../../features/organization/hooks/useOrganization";
import { useCoach } from "../../../features/coach/contexts/CoachProvider";
import { DropdownChevronPair } from "../DropdownChevronPair";

interface MobileOrgSelectorProps {
  onClose?: () => void;
}

const MobileOrgSelector: React.FC<MobileOrgSelectorProps> = ({ onClose }) => {
  const { organizations, isCoach } = useProfile();
  const { currentOrganization } = useOrganization();
  const [expanded, setExpanded] = useState(false);
  const { setOrganizationId } = useCoach();

  if (!isCoach || !organizations || organizations.length <= 1) return null;

  return (
    <div className="border-b border-[#f0f3fa]">
      <button
        onClick={() => setExpanded((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-3 bg-transparent border-0 cursor-pointer hover:bg-[#f8f9ff] transition-colors"
      >
        <div className="flex items-center gap-2">
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#7b9ded"
            strokeWidth="2"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          <span className="text-[13px] font-semibold text-[#26295e] font-primary">
            {currentOrganization?.name ?? "Organization"}
          </span>
        </div>
        <DropdownChevronPair className="border-[#dfe3ec] bg-[#f4f6fa] text-[#9ba5b4]" />
      </button>

      {expanded && (
        <div className="bg-[#f8f9ff] border-t border-[#f0f3fa]">
          {organizations.map((org) => {
            const isActive = org.id === currentOrganization?.id;
            return (
              <button
                key={org.id}
                onClick={() => {
                  setOrganizationId(String(org.id));
                  setExpanded(false);
                  onClose?.();
                }}
                className="w-full flex items-center gap-2 pl-8 pr-4 py-2.5 border-0 cursor-pointer text-left transition-colors hover:bg-[#eef1fb] bg-transparent"
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#7b9ded"
                  strokeWidth="2"
                >
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                  <polyline points="9 22 9 12 15 12 15 22" />
                </svg>
                <span
                  className={`text-[12px] font-primary flex-1 truncate ${
                    isActive
                      ? "text-[#5d4cc6] font-semibold"
                      : "text-[#26295e] font-medium"
                  }`}
                >
                  {org.name}
                </span>
                {isActive && (
                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#5d4cc6"
                    strokeWidth="2.5"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MobileOrgSelector;
